
<div class="loader" *ngIf="show">
  <div class="loader-card">
    <i class="fa fa-spinner fa-spin loader-spinner"></i>
    <p class="loader-message" *ngIf="message">{{ message }}</p>
    <p class="loader-progress" *ngIf="progressText">{{ progressText }}</p>
    <p class="loader-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
  </div>
</div>
